import React from 'react';
import PropTypes from 'prop-types';
import 'swiper/swiper-bundle.css';
import SwiperCore from 'swiper';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import TabItemsImage from '../tabItemsImage/tabItemsImage';
import TabItemsContent from '../tabItemsContent/tabItemsContent';
import styles from './tabModuleMobile.module.scss';

SwiperCore.use([EffectCoverflow, Pagination]);

function TabModuleMobile({ items = [] }) {
  const swiperConfig = {
    slidesPerView: '1',
    speed: 1500,
    autoHeight: false,
    noSwiping: false,
    noSwipingClass: 'swiper-slide',
    centeredSlides: true,
    spaceBetween: 5,
    pagination: { clickable: true },
  };

  return (
    <div className={styles.panelWrapper}>
      <Swiper {...swiperConfig} className={styles.tabsContent}>
        {items?.map((item) => {
          return (
            <SwiperSlide
              key={item?.tokenKey.toString()}
              className={styles.swiperSlideItem}
            >
              <TabItemsImage {...item?.image} />
              <TabItemsContent
                content={item?.content}
                cta={item?.cta}
                tokenKey={item?.tokenKey}
              />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

TabModuleMobile.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.any,
      image: PropTypes.any,
      cta: PropTypes.shape({
        label: PropTypes.string,
        link: PropTypes.any,
      }),
      tokenKey: PropTypes.string,
    })
  ),
};

export default TabModuleMobile;
